export const commonDefaultProps = {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
};
